import Vue from 'vue'
import App from './App.vue'
import moment from 'moment'
import 'moment/locale/zh-cn'
import router from './router'
import store from './store/'
import VueStorage from 'vue-ls'
import projectConfig from '@/config/projectConfig'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.less'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import bootstrap from './core/bootstrap'
import MultiTab from '@/components/MultiTab'
import SvgIcon from '@/components/SvgIcon' // svg component

moment.locale('zh-cn')

// lov注册
import LovPlugin from '@/components/Lov/lovPlugin'

Vue.use(LovPlugin)
// register globally
Vue.component('SvgIcon', SvgIcon)
Vue.use(MultiTab)
// 权限控制
import { has, role, plugin } from '@/utils/authorize'
Vue.use(has)
Vue.use(role)
Vue.use(plugin)

Vue.use(ElementUI)
Vue.config.productionTip = false
Vue.use(Antd)
Vue.use(VueStorage, projectConfig.storageOptions)
import './permission' // permission control
import VueCropper from 'vue-cropper'
import VueClipboard from 'vue-clipboard2'
VueClipboard.config.autoSetContainer = true
Vue.use(VueClipboard)
Vue.use(VueCropper)
// 字典注册
import DictPlugin from '@/components/Dict/dictPlugin'
Vue.use(DictPlugin)
// 文件相对路径转绝对路径
Vue.prototype.fileAbsoluteUrl = function (relativeUrl) {
  if (relativeUrl) {
    return 'https://hccake-img.oss-cn-shanghai.aliyuncs.com/' + relativeUrl
  }
}
new Vue({
  beforeCreate() {
    // 全局事件总线
    Vue.prototype.$bus = this
  },
  router,
  store,
  created: bootstrap,
  render: (h) => h(App),
}).$mount('#app')
